import React, { useEffect, useRef, useState } from "react";
import axios from "../../../axios";
import { SubjectIcon } from "../../../SubjectIcon";
import SubjectCountBoxList from "./SubjectCountBoxList";
import { ChevronLeft, ChevronRight } from "lucide-react";

function SubjectCountBox({ filter, from }) {
  console.log(from, "rfrom whihc pafe ");
  const [variable, setVariable] = useState([]);
  const [isGettingData, setIsGettingData] = useState(true);
  const scrollContainerRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const scrollRight = () => {
    scrollContainerRef.current?.scrollBy({ left: 400, behavior: "smooth" });
  };

  const scrollLeft = () => {
    scrollContainerRef.current?.scrollBy({ left: -400, behavior: "smooth" });
  };

  useEffect(() => {
    let Teacher_id = localStorage.getItem("Teacher_id");
    let Teacher_Json = JSON.parse(Teacher_id);
    const timetableSessionId = localStorage.getItem("timeTableSessionId");
    const timeTable_Json = JSON.parse(timetableSessionId);
    const helper = async () => {
      let response = await axios.get(
        `/api/v1/assessment/teacherSummary/get/teacherId/${Teacher_Json}?offlineMode=true&timetableSessionId=${timeTable_Json}&standardId=${filter.standard_id}&sectionId=${filter.section_id}`,
      );
      response && setVariable(response.data.data);
      setIsGettingData(false);
    };
    if (Teacher_Json !== null) {
      helper();
    }
  }, [filter.standard_id, filter.section_id]);
  return (
    <>
      <div
        className="publish_summery_container gap-3 mb-2 mt-2 px-1"
        style={{
          width: "auto",
          backgroundColor: "#f2f2f2",
          overflowX: "auto",
          overflowY: "hidden",
        }}
      >
        {/* Loading */}
        {isGettingData ? (
          <div className="text-center w-100 py-3">
            <div className="spinner-border text-warning" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <div
            ref={scrollContainerRef}
            className="publish_summery_container mb-4 gap-3 d-flex align-items-center "
            style={{
              overflowX: "auto",
              scrollBehavior: "smooth",
              alignItems: "center",
              position: "relative",
              minHeight: "150px",
            }}
          >
            {/* Left Sticky Button */}
            {isOverflowing && (
              <button
                type="button"
                className="btn btn-light d-flex align-items-center justify-content-center shadow"
                onClick={scrollLeft}
                style={{
                  position: "sticky",
                  left: 0,

                  top: "50%",
                  transform: "translateY(-50%)",
                  borderRadius: "50%",
                  backgroundColor: "#FDEFE3",
                  width: "40px",
                  height: "40px",
                  border: "1px solid #4B4B4B",
                }}
              >
                <ChevronLeft color="#4B4B4B" size={24} />
              </button>
            )}

            {/* Subject Cards */}

            {!isGettingData && variable.length > 0 ? (
              variable.map((obj, index) => (
                <SubjectCountBoxList
                  subname={obj?.subject?.name}
                  sublogo={
                    SubjectIcon?.find(
                      (i) => i.subjectName === obj?.subject?.name,
                    )?.icon || "/subIcon/ic_png_science.png"
                  }
                  draft={obj?.in_draft}
                  completed={obj?.completed}
                />
              ))
            ) : !isGettingData ? (
              <span className="ms-3">Subject-wise Assessment Not Found</span>
            ) : null}

            {/* Right Sticky Button */}
            {isOverflowing && (
              <button
                type="button"
                className="btn btn-light d-flex align-items-center justify-content-center shadow"
                onClick={scrollRight}
                style={{
                  position: "sticky",
                  right: 0,
                  zIndex: 0,
                  top: "50%",
                  transform: "translateY(-50%)",
                  borderRadius: "50%",
                  backgroundColor: "#FDEFE3",
                  width: "40px",
                  height: "40px",
                  border: "1px solid #4B4B4B",
                }}
              >
                <ChevronRight color="#4B4B4B" size={24} />
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default SubjectCountBox;
